import { process as f } from "./process.js";
import { global as s } from "./global.js";
import { queueResizeObserver as h } from "./queueResizeObserver.js";
var n = 0, d = function() {
  return !!n;
}, p = 250, l = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, u = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], a = function(t) {
  return t === void 0 && (t = 0), Date.now() + t;
}, i = !1, b = function() {
  function t() {
    var e = this;
    this.stopped = !0, this.listener = function() {
      return e.schedule();
    };
  }
  return t.prototype.run = function(e) {
    var r = this;
    if (e === void 0 && (e = p), !i) {
      i = !0;
      var c = a(e);
      h(function() {
        var o = !1;
        try {
          o = f();
        } finally {
          if (i = !1, e = c - a(), !d())
            return;
          o ? r.run(1e3) : e > 0 ? r.run(e) : r.start();
        }
      });
    }
  }, t.prototype.schedule = function() {
    this.stop(), this.run();
  }, t.prototype.observe = function() {
    var e = this, r = function() {
      return e.observer && e.observer.observe(document.body, l);
    };
    document.body ? r() : s.addEventListener("DOMContentLoaded", r);
  }, t.prototype.start = function() {
    var e = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), u.forEach(function(r) {
      return s.addEventListener(r, e.listener, !0);
    }));
  }, t.prototype.stop = function() {
    var e = this;
    this.stopped || (this.observer && this.observer.disconnect(), u.forEach(function(r) {
      return s.removeEventListener(r, e.listener, !0);
    }), this.stopped = !0);
  }, t;
}(), v = new b(), E = function(t) {
  !n && t > 0 && v.start(), n += t, !n && v.stop();
};
export {
  v as scheduler,
  E as updateCount
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/utils/scheduler.js
// module id = 1317
// module chunks = 41